module.exports = __webpack_public_path__ + "static/img/IN-2016.4125392.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/custom/IN-2016.jpg
// module id = Z6Iu
// module chunks = 0